let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = Promise.all([load("h2MrD"), load("bYT2S"), load("hPzOn"), load("dsiAd"), load("3G8pv")]).then(() => parcelRequire('1jMgA'));